/**
 * @component StatusBadge
 * @description Status-Anzeige mit farbigem Punkt-Indikator.
 * Unterstuetzt vordefinierte Status (aktiv, laufend, offen, etc.)
 * mit automatischer Farbzuordnung und i18n-Uebersetzung.
 *
 * @prop {string} status      - Status-Schluessel (z.B. 'aktiv', 'offen', 'bezahlt')
 * @prop {string} [className] - Optionale CSS-Klassen
 * @usage Verwendet in Tabellen und Detailseiten fuer Datensatz-Status
 */
import { useLanguage } from '../../context/LanguageContext';

const STATUS_MAP = {
  aktiv:          { color: 'bg-emerald-500', labelKey: 'status.active' },
  laufend:        { color: 'bg-emerald-500', labelKey: 'status.running' },
  genehmigt:      { color: 'bg-emerald-500', labelKey: 'status.approved' },
  entwurf:        { color: 'bg-amber-500',   labelKey: 'status.draft' },
  beantragt:      { color: 'bg-amber-500',   labelKey: 'status.requested' },
  offen:          { color: 'bg-amber-500',   labelKey: 'status.open' },
  bezahlt:        { color: 'bg-emerald-500', labelKey: 'status.paid' },
  überfällig:     { color: 'bg-red-500',     labelKey: 'status.overdue' },
  bestaetigt:     { color: 'bg-emerald-500', labelKey: 'status.confirmed' },
  verteilt:       { color: 'bg-primary-500',    labelKey: 'status.distributed' },
  geplant:        { color: 'bg-cyan-500',     labelKey: 'status.planned' },
  inaktiv:        { color: 'bg-gray-400',    labelKey: 'status.inactive' },
  abgelehnt:      { color: 'bg-red-500',     labelKey: 'status.rejected' },
  storniert:      { color: 'bg-red-500',     labelKey: 'status.cancelled' },
  abgeschlossen:  { color: 'bg-primary-500',    labelKey: 'status.completed' },
  archiviert:     { color: 'bg-gray-400',    labelKey: 'status.archived' },
  ruhend:         { color: 'bg-amber-500',   labelKey: 'status.dormant' },
  unbekannt:      { color: 'bg-gray-400',    labelKey: 'status.unknown' },
};

export function StatusBadge({ status, className = '' }) {
  const { t } = useLanguage();
  const key = (status || '').toLowerCase();
  const cfg = STATUS_MAP[key] || { color: 'bg-gray-400', labelKey: null };

  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-medium text-content ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.color}`} />
      {cfg.labelKey ? t(cfg.labelKey) : (status || '\u2014')}
    </span>
  );
}
